import React from 'react'
import PropTypes from 'prop-types'
import { SwitchLabel, HiddenInput, Track, Thumb, LabelText } from './styles'

export const ToggleSwitch = ({ checked, onChange, disabled, label }) => {
  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked)
    }
  }

  return (
    <SwitchLabel $disabled={disabled}>
      <HiddenInput
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <Track $checked={checked}>
        <Thumb $checked={checked} />
      </Track>
      {label && <LabelText>{label}</LabelText>}
    </SwitchLabel>
  )
}

ToggleSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
}

ToggleSwitch.defaultProps = {
  checked: false,
  disabled: false,
}
